import { useQuery } from "@tanstack/react-query";
import { ExternalSecurityControlCardRequestService } from "../../../../../services/company-office/ExternalSecurityControlCardService";
// import { useSelector } from "../../../../../store/store";
import {
  getStatusBaseOnApprover,
  getStepBaseOnApprover,
} from "../../../info-technology-process/delete-user-account/utils";
import { transformRequestStatus } from "../../../utils";
import { useSelector } from "../../../../../store/store";

export const useSecurityCardUnitsRequests = () => {
  const user = useSelector((state) => state.user);
  const userEmail = user?.current?.username;

  const { data = [], ...restResponse } = useQuery<Array<any>>({
    queryKey: ["security-card-units-requests"],
    queryFn: () => ExternalSecurityControlCardRequestService.getExternalSecurityControlCardRequests(userEmail),
  });

  const securityCardUnitsMyRequests = data.filter(
    (el) => el.createdBy.user.email.toLowerCase() === userEmail.toLowerCase()
  );

  const processedData = data
    .map((record) => {
      const status = getStatusBaseOnApprover(record.fields, userEmail);
      const step = getStepBaseOnApprover(record.fields, userEmail);

      return {
        ...record.fields,
        id: record.id,
        createdByEmail: record.createdBy.user.email,
        createdByName: record.createdBy.user.displayName,
        createdDateTime: record.createdDateTime,
        eRequestStatus: transformRequestStatus(status, { step }),
      };
    })
    .sort((a, b) => b.id - a.id);

  const mappedSecurityCardUnitsRequests = processedData
    .filter((record) => [record.eAssignee, record.eApprovedByITLead, record.eApprovedByITHead, record.eApprovedBy].some((approver) => approver?.toLowerCase().includes(userEmail.toLowerCase())))

  const mappedSecurityCardUnitsMyRequests = processedData
    .filter((record) => record.createdByEmail.toLowerCase() === userEmail.toLowerCase())

  const guideLink = "https://drive.google.com/file/d/1uHUNK6JFcFFOt_d7ULlr4n6F7Z4cC82M/view?usp=drive_link";

  return {
    ...restResponse,
    securityCardUnitsRequests: data,
    securityCardUnitsMyRequests,
    mappedSecurityCardUnitsRequests,
    mappedSecurityCardUnitsMyRequests,
    guideLink,
  };
};
